import ListItem from "@mui/material/ListItem";
import { useState } from "react";
import { DataViewer } from "@/features/data-viewer/data-viewer";
import { PanelLayoutToggle } from "@/features/data-viewer/spec/panel-layout-toggle";
import { type PanelLayout, useZoneDataViewerSpec } from "@/features/data-viewer/spec/use-data-viewer-spec";
import { CLOCK_CADENCE } from "@/providers/wall-clock";

/** Its own component so the streams request only runs when the flag lets the viewer render. */
export function ZoneDataViewerSection({ zoneId }: { zoneId: string }) {
    const [panelLayout, setPanelLayout] = useState<PanelLayout>("single");
    const { spec: zoneSpec, isLoading, isError, isEmpty } = useZoneDataViewerSpec(zoneId, panelLayout);

    return (
        <ListItem className={"FullsizeZoneOverviewListItem--InfoCard"}>
            <div className={"w-full flex flex-col"}>
                <DataViewer
                    controls={<PanelLayoutToggle layout={panelLayout} onChange={setPanelLayout} />}
                    initialSpec={zoneSpec}
                    isLoading={isLoading}
                    isError={isError}
                    isEmpty={isEmpty}
                    autoRefreshCadence={CLOCK_CADENCE.MINUTES_5}
                    resizable={false}
                />
            </div>
        </ListItem>
    );
}
